export const AllPublicationImg = require("./nmg-network-pHQC7md2l2o-unsplash.jpg")
export const AllTemplateImg = require("./nick-adams-yTWq8n3-4k0-unsplash.jpg")
export const BusinessCardsImg = require("./kate-trysh-WX5jK0BT5JQ-unsplash.jpg")
export const EditorialStaffImg = require("./christopher-gower-m_HRfLhgABo-unsplash.jpg")
export const EmployerNewsletterImg = require("./ben-kolde-bs2Ba7t69mM-unsplash.jpg")
export const EventsImg = require("./jonas-jacobsson-2xaF4TbjXT0-unsplash.jpg")
export const ImagePoolImg = require("./annie-spratt-5ABow0uVv_k-unsplash.jpg")
export const NewsImg = require("./news.jpg")
export const SpreadPublicationsImg = require("./kari-shea-oYUgmpHj5V8-unsplash.jpg")
export const TemplateDefaultImg = require("./template1.jpg")